import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { makeStyles } from '@material-ui/core/styles';
import { get } from 'lodash';
import Link from '../Link';
import { useTheme } from '@material-ui/core/styles';

import useMediaQuery from '@material-ui/core/useMediaQuery';
import Button from '@material-ui/core/Button';

const useStyles = makeStyles(theme => ({
  root: {
    background: 'white',
    padding: '20px',
    position: 'fixed',
    bottom: '0',
    left: '0',
    right: '0',
    zIndex: '10',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    boxShadow: '0 0 10px 0 rgba(0, 0, 0, 0.5)',
    '& > p': {
      fontSize: '.9rem',
      [theme.breakpoints.up('xs')]: {
        margin: '0px'
      }
    },
    '& a': {
      color: 'black',
      textDecoration: 'underline'
    },
    [theme.breakpoints.down('xs')]: {
      flexDirection: 'column',
      padding: '20px',
      textAlign: 'center'
    }
  },
  button: {
    minWidth: '150px',
    textAlign: 'center',
    [theme.breakpoints.down('xs')]: {
      marginTop: '10px'
    }
  }
}));

export default function CookieCompliance() {
  const theme = useTheme();
  const classes = useStyles();
  const dispatch = useDispatch();
  const { isMobile } = useMediaQuery(theme.breakpoints.down('600'));
  const showDialog = useSelector(state => get(state, 'cookieCompliance.show'));

  const acceptAllSettings = () => {
    dispatch({
      type: 'COOKIE_COMPLIANCE/SAVE',
      analytics: true
    });
  };

  if (!showDialog) {
    return null;
  } else {
    return (
      <div className={classes.root}>
        <p className="medium text-info my-10">
          This website stores data such as cookies to enable important site functionality including
          analytics, targeting, and personalization. <br></br>By using this website you agree to our{' '}
          <Link className="small" to="/privacy-policy">
            Privacy Policy
          </Link>{' '}
          and{' '}
          <Link className="small" to="/terms-of-service">
            Terms of Service
          </Link>
          .
        </p>
        <div className={isMobile ? 'flex-row-center' : 'flex-row-end'}>
          <Button
            // className={`button solid ${classes.button}`}
            onClick={acceptAllSettings}
            color="primary"
            variant="contained"
            disableElevation>
            Got It
          </Button>
        </div>
      </div>
    );
  }
}
